/**
 * FilterBar Component
 *
 * Shared filter bar pattern used by list pages.
 *
 * @package MultilingualPressZone
 */

import { el } from '../utils/dom.js';

/**
 * Render a filter group.
 *
 * @param {Object} options
 * @param {string} options.label
 * @param {string} options.forId
 * @param {HTMLElement} options.control
 * @param {string} [options.className]
 * @return {HTMLElement}
 */
export function FilterGroup({ label, forId, control, className = '' } = {}) {
    return el('div', { class: ['mpz-filter-group', className].filter(Boolean).join(' ') },
        el('label', { for: forId, class: 'mpz-filter-label' }, String(label || '')),
        control
    );
}

/**
 * Render a filter bar wrapper.
 *
 * @param {Object} options
 * @param {Array<HTMLElement>} options.groups
 * @param {string} [options.className]
 * @return {HTMLElement}
 */
export function FilterBar({ groups = [], className = '' } = {}) {
    const safeGroups = Array.isArray(groups) ? groups.filter(Boolean) : [];

    return el('div', { class: ['mpz-filters', className].filter(Boolean).join(' ') },
        el('div', { class: 'mpz-filters__row' }, ...safeGroups)
    );
}

export default FilterBar;
